import { z } from 'zod';

export const addCartItemSchema = z.object({
  variantId: z.string().uuid(),
  quantity: z.number().int().min(1).max(999),
  // Custom product options (spec section 6: "required customer notes", options)
  customOptions: z.record(z.string(), z.string().max(2000)).optional(),
  note: z.string().max(2000).optional(),
});

export const updateCartItemSchema = z.object({
  quantity: z.number().int().min(0).max(999),
  customOptions: z.record(z.string(), z.string().max(2000)).optional(),
  note: z.string().max(2000).optional(),
});

export const mergeCartSchema = z.object({
  guestCartId: z.string().uuid(),
});

export type AddCartItemInput = z.infer<typeof addCartItemSchema>;
